import { FC } from 'react';

import { Guardian } from 'store/candidate/types';

import { FormFields } from '@britishcouncil/react-forms';
import { TextField } from '@britishcouncil/react-solas-ors3';

export const GuardianFields: FC<{ fields: FormFields<Guardian> }> = ({ fields }) => {
  return (
    <>
      <TextField label="Family name *" {...fields.familyName} showColon={false} />
      <TextField label="Other/given names *" {...fields.otherNames} showColon={false} />
      <TextField label="Relationship to the child" {...fields.relationship} showColon={false} />
      <TextField label="Alternative contact number *" {...fields.telephone} showColon={false} />
    </>
  );
};
